module.exports = __webpack_public_path__ + "static/mosforum.60126868.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/assets/mosforum.png
// module id = 987
// module chunks = 114276838955818